import reducer from './reducers';

import * as studentActions from './actions';

export {
  studentActions,
};

export default reducer;
